import "./terapiasHolisticas.css";
import Tarjeta from "../Tarjeta/Tarjeta";
import FadeInSection from "../FadeInSection/FadeInSection";
import { useServiciosCombinados } from "../../hook/useServiciosCombinados";
import { useConvertor } from "../../hook/useConversor";
import { useMoneda } from "../../context/MonedaContext";

const TerapiasHolisticas = () => {
  const { combinados, cargando, error } = useServiciosCombinados();
  const {moneda} = useMoneda();
  const {preciosConvertidos} = useConvertor(combinados,moneda)

  if (cargando) return <p className="cargando">Cargando...</p>;
  if (error) return <p className="error">Error: {error}</p>;

  const terapias = combinados.slice(7, 12);
  console.log(terapias)

  return (
    <section className="jbSeccionTemporal">
      <h1 className="jbTituloTH">Terapias Holisticas</h1>
      <FadeInSection>
        <div className="jbContenedorTarjetas">
          {terapias.map((servicio) => (
            <Tarjeta key={servicio.id} servicio={{
              ...servicio,
                precioConvertido: preciosConvertidos[servicio.id]
            }} 
            moneda = {moneda}
            />
          ))}
        </div>
      </FadeInSection>
    </section>
  );
};

export default TerapiasHolisticas;
